export default "__VITE_ASSET__CLz0Di3i__"